export default {en: {
  "general": {
    "yes": "Yes",
    "no": "No",
    "validate": "Confirm",
    "cancel": "Cancel",
    "accept": "Accept",
    "reject": "Refuse",
    "send": "Send",
    "go": "Go !",
    "close": "Close",
    "retry": "Retry",
    "disconnect": "You have lost connexion",
    "reconnect": "Reconnect",
    "speaker": "speaker",
    "manager": "manager",
    "moderator": "moderator",
    "admin": "administrator",
    "refreshList": "Refresh list",
    "back": "Back"
  },
  "landing": {
    "button": "Enter the room",
    "duration": "{duration} min",
    "countdown": "Your webinar starts in",
    "days": "days",
    "hours": "hours",
    "minutes": "minutes",
    "seconds": "seconds",
    "day": "day",
    "hour": "hour",
    "minute": "minute",
    "second": "second"
  },
  "room": {
    "header": {
      "quit": "Leave",
      "interface": {
        "open": "Open",
        "header": "Settings",
        "close": "Close"
      },
      "bandwidth": {
        "open": "Open",
        "header": "Bandwidth test",
        "close": "Close"
      }
    },
    "footer": {
      "info": "French leader in the organization of online BtoB conferences"
    }
  },
  "language": {
    "select": {
      "fr": "Français",
      "en": "English"
    }
  },
  "helps": {
    "open": "Open",
    "header": "Need help ?",
    "close": "Close"
  },
  "tools": {
    "chat": "Chat",
    "files": "files",
    "publicChat": "Chat",
    "privateChat": "Private chat",
    "team": "Team",
    "audience": "Attendees",
    "poll": "Polls",
    "graphs": "Statistics",
    "downloading": "Downloadings",
    "onLine": "Online",
    "banned": "Banned",
    "favorites": "Favorites"
  },
  "modal": {
    "changeRoomStatus": {
      "toDraft": {
        "title": "The webinar has been updated !",
        "content": "To access to the last update, please refresh your page."
      },
      "toLive": {
        "title": "Your webinar starts soon !",
        "content": "From now, you can train as a team before launching the live to the audience. Please refresh your page."
      }
    },
    "liveToReplay": {
      "title": "The webinar is over !",
      "content": "In 15 seconds, you will be redirected to the replay of the webinar.",
      "button": "Watch the replay"
    },
    "dropConnection": {
      "title": "We have detected a drop on your connection !",
      "content": "Please, close one of your stream to ensure a better quality of use."
    },
    "broadcastTimer": {
      "message": "Get ready ! You'll be live in a few seconds",
      "seconds": "seconds"
    }
  },
  "streamInformations": {
    "title": "Streaming informations",
    "helper": "Here the RTMP streaming informations",
    "copy": "Copy",
    "noInfo": "Please first start a test to get this information"
  },
  "userHelp": {
    "init": {
      "title": "Find all your settings on the button at the top right."
    },
    "launchBroadcast": {
      "title": "Broadcast the webinar to your audience",
      "content": "Please make sure you are ready. As soon as the broadcast starts, your webcam, microphone and the selected document will be shared with the audience. If you deactivate the button, the broadcast will stop. You will not be able to start the broadcast again.",
      "footer": "The button is available only 15 min before the beginning of the webinar."
    },
    "testLive": {
      "title": "Train before the D-day",
      "content": "Activate the test button to broadcast video, sound and countent. You are allotted a 60 minutes test session that you can use all at once or over several tests. The attendees will not be able to access it.",
      "footer": "Don’t forget to stop the test once you are finished. If you need to recharge your test session, please contact the Webikeo team."
    },
    "giveVoice": {
      "title": "Grant your speaker the permission to speak",
      "content": "Click on the « live OFF » button to let your speakers join the live. They will able to activate their camera and microphone to appear on your screen.",
      "footer": "These commands can be activated 1 hour before your webinar begins or during a test session activated by the room director."
    },
    "giveVoiceSpeaker": {
      "title": "To know who's live",
      "content": "When a speaker join the live, a \"Live ON\" spot appears beside his name.",
      "footer": "Only people having this spot can broadcast."
    },
    "toolsDocs": {
      "title": "Take the floor, you are live!",
      "content": "Once you have been authorized to join the live by the room director, you can activate your microphone and camera. The broadcast must have started for your actions to be visible by the audience.",
      "footer": "These commands can be activated 1 hour before your webinar begins or during a test session activated by the room director."
    },
    "toolsDocsSpeaker": {
      "title": "Take the floor, you're live !",
      "content": "Once the manager authorized you to join the live, you can activate your command to appear on the screen. The webinar has to start to make your actions visible to the audience.",
      "footer": "These commands can be activated 1 hour before your live, or during a test session activated by your manager."
    },
    "toolsDocsShare": {
      "title": "Broadcast contents",
      "content": "You can share your screen or broadcast documents (PDF, videos or images) directly from the console. Please start the broadcast to make your actions visible to the audience.",
      "footer": "These commands can be activated 1 hour before your webinar begins or during a test session activated by the room director."
    },
    "downloadDocs": {
      "title": "Allow the audience to download documents",
      "content": "You can select the documents you want to make available for download in the console. Your attendees will be able to download the documents as soon as they enter the room.",
      "footer": "You can unselect the documents available for download in the console at any time."
    },
    "downloadDocsStudio": {
      "title": "Allow the audience to download a document",
      "content": "You can upload documents in this space. Click on the menu and select the ones you want make it available for download for your participants.",
      "footer": "You can cancel the downloading access at any time from the menu. "
    },
    "rightToolsSpectator": {
      "title": "Chat with your audience",
      "content": "This is were you can see and answer your attendees’ questions. You can moderate the chat and favorite the questions you want to answer later.",
      "footer": "Any message sent in the public chat will be seen by all attendees. You can delete a message in the chat at any time."
    },
    "rightToolsPolls": {
      "title": "Challenge and learn about your audience",
      "content": "You can create polls to get to know your attendees better or test their knowledge. You will be able to decide whether or not to share the results with them.",
      "footer": "If you start the poll before your webinar begins, your audience will be able to take part in the poll as soon as they enter the room. You can delete your polls or reset them if necessary."
    },
    "askLive": {
      "title": "Join the live stream to broadcast",
      "content": "To be able to activate your broadcast orders and be visible to the team, you must join the live. The manager can at any time ask you to join the live, you will receive a message allowing you to accept or decline his request.",
      "footer": "This command can be activated 1 hour before your live, or during a test session activated by your manager. This command sends a request for permission to speak."
    }
  },
  "poll": {
    "titleIntro": "You have not created any poll yet",
    "titleStep1": "What is your question?",
    "titleStep2": "What are your answers?",
    "titleStep3": "Add options to your survey",
    "typeTitle": "Write your question",
    "typeAnswer": "Write your answer",
    "addAnswer": "Add an answer",
    "manyAnswers": "Allow multiple answers",
    "whiteVote": "Allow a blank vote",
    "autoResult": "Automatically share the results with participants at the end of the votes",
    "answersTime": "Define a response time",
    "allowedAnswers": "authorized responses",
    "votesShared": "The votes were split",
    "votesClosed": "Votes are closed",
    "votesOpen": "The votes are open",
    "returnListPolls": "Back to the list of polls",
    "deletePoll": "The poll has been deleted",
    "noPoll": "No poll has been proposed at this time...",
    "noPoll2": "A notification",
    "noPoll3": "will alert you as soon as a poll is proposed.",
    "thanks": "Thank you for your participation!",
    "new": "New",
    "inProgress": "In progress",
    "answered": "Answered",
    "fenced": "Closed",
    "results": "Results",
    "confirmDeletePoll": "Are you sure you want to delete this poll?",
    "confirmResetPoll": "Are you sure you want to restart this poll?",
    "button": {
      "finalize": "Finalize the poll",
      "openPolls": "Open the votes",
      "closePolls": "Close votes",
      "shareResults": "Share the results",
      "quitPoll": "Leave the poll",
      "deletePoll": "Delete the poll",
      "backListPoll": "Back to the list of polls",
      "ignorePoll": "Ignore the poll",
      "vote": "Vote",
      "particip": "I participate"
    },
    "filter": {
      "title": "Show",
      "allPolls": "All polls",
      "myPolls": "My own polls",
      "openPolls": "Open polls",
      "closePolls": "Completed polls"
    },
    "expire": "This poll has expired",
    "answered": "Your answer has been taken into account"
  },
  "button": {
    "minChar": "minimum characters"
  },
  "field": {
    "required": "This field is required"
  },
  "at": "at",
  "bot": {
    "technicalAssistant": "Assistant Webikeo"
  },
  "all": "All",
  "search": "Search",
  "noResult": "No results found",
  "notRead": "Unread messages",
  "notReadOne": "Unread message",
  "team": {
    "placeholderForm": "Your message",
    "me": "Me",
    "send": "Sent",
    "waiting": "waiting for validation",
    "moderated": "This chat is subject to moderation",
    "messageAddFavorite": "Add to favorites",
    "messageRemoveFavorite": "Remove from favorites"
  },
  "participants": {
    "banish": "Banish from the room",
    "unbanish": "Reauthorize access to the room",
    "blacklistOnChat": "Banish from the chat",
    "autoriseChat": "Allow access to the chat",
    "blacklistUserToChatMsg": "You were banned from the chat room!",
    "autorisedUserToChatMsg": "You can use the chat again.",
    "blacklistUserOnRoomMsg": "You were banned from the room!",
    "unblacklistUserOnRoomMsg": "You are no longer banned from the room!"
  },
  "graphs": {
    "presence": "Participation"
  },
  "documents": {
    "titleMenu": "Downloadable documents",
    "subTitleMenu": "Select the documents that your participants will be able to download",
    "save": "Save",
    "dragDrop": "Drag and drop your files here",
    "nothing": "No document available for download at the moment...",
    "infoPublication": "This action will replace the current broadcast",
    "sortDocuments": "Sort your files to broadcast",
    "processing": "processing",
    "failed": "failed"
  },
  "error-page": {
    "text1": "The server had a problem",
    "text2": "Try to refresh the page.",
    "text-403": "It seems you're not allowed to come here.",
    "text-403-0": "Generic error message (invalid token, expired token,...)",
    "text-403-1": "You have already opened another browser tab/browser.",
    "text-403-2": "You have already opened another browser tab/browser.",
    "text-403-3": "Too many connected speakers for this role (more than one admin, more than one manager,...)",
    "text-403-4": "The speaker has a role that is not managed by the application.",
    "text-404": "The page you are looking for is not found.",
    "button": "Return"
  },
  "header": {
    "profile": "My profile",
    "precallTest": "Settings",
    "emptyPublicChat": "Delete chat",
    "recording": "Recording options",
    "language": "Language",
    "playRecording": "Restart recording",
    "pauseRecording": "Pause the recording",
    "userHelp": "Need help?",
    "helpDesk": "Report a problem",
    "streamInformations": "Streaming informations",
    "hotline": "ASSISTANCE"
  },
  "system-check": {
    "text1": "Please wait a moment...",
    "text2": "We are checking your connection...",
    "text3": "Your configuration is not optimal",
    "text4": "You can consult the test results below",
    "text5": "Everything is ready!",
    "detail": "See the details",
    "button": "Next",
    "button2": "Restart the test",
    "button3": "Enter the room"
  },
  "control": {
    "live": "LIVE",
    "testLive": "TEST THE LIVE",
    "showLive": "SHOW THE LIVE",
    "testLiveClose": "LIVE TEST OVER",
    "testInProgress": "TEST IN PROGRESS",
    "launchBroadcast": "START BROADCAST",
    "liveInProgress": "LIVE IN PROGRESS",
    "liveClose": "WEBINAR IS OVER",
    "confirmBroadcast": "Thank you for confirming the webinar broadcast!",
    "confirmCloseBroadcast": "Are you sure you want to stop the webinar?",
    "confirmEmptyPublicChat": "Are you sure you want to delete the content of the chat?",
    "confirmDeleteChatMessage": "Are you sure you want to delete this chat message?",
    "confirmResetRoom": {
      "text1": "Are you sure you want to reset the room?",
      "text2": "All room data will be permanently deleted.",
      "text3": "THIS ACTION IS IRREVERSIBLE!"
    },
    "notAllowedBroadcastStart": "You can start the broadcast 15 minutes before the webinar starts.",
    "testLiveText-1": "You can test the live and talk with your speakers for 60 minutes.",
    "testLiveText-2": "Don't forget to disable the button at the end of your session.",
    "testLiveText-3": "To activate your comman`d`s,",
    "testLiveText-4": "you have to start the test.",
    "testLiveText-5": "Your test session is over.",
    "testLiveText-6": "Contact Webikeo if you want to extend your test session."
  },
  "profile": {
    "title": "My profile",
    "lastname": "Name",
    "firstname": "First name",
    "function": "Function",
    "company": "Company",
    "email": "Email",
    "description": "About You",
    "button": "Save",
    "ignore": "Ignore"
  },
  "parameters": {
    "text1": "To prepare your webinar in the best conditions",
    "text2": "Select and test your equipment",
    "text3": "One last detail...",
    "text4": "Check your profile information before it is visible to everyone",
    "buttonIgnore": "Ignore",
    "buttonEdit": "Edit my profile",
    "buttonTest": "Test my material"
  },
  "devices": {
    "title": "Test your connection and material",
    "close": "Save",
    "buttonTest": "Test"
  },
  "browser": {
    "console": "Your browser is not compatible with the console."
  },
  "broadcast": {
    "notStarted": "Your live will start shortly.",
    "ended": "Your live is now complete."
  },
  "confirm": {
    "askingFor": {
      "live": {
        "title": "Request to join the live",
        "content": "By accepting this request, you authorize this speaker to join the live and broadcast content."
      },
      "document": {
        "title": "This speaker would like to share other content",
        "content": "If you accept this request, this content will replace the current sharing."
      },
      "screenSharing": {
        "title": "Request for screen sharing",
        "content": "By accepting this request, you are allowing this speaker to share his screen. You can take control at any time."
      }
    },
    "askLive": {
      "request": {
        "title": "Request to join the live"
      }
    },
    "askForceLive": {
      "response": {
        "title": "The manager invites you to join the live ",
        "content": "By accepting this request, you could broadcast content."
      }
    },
    "playBroadcast": {
      "title": "Start the live",
      "content": "Remember to start the live by clicking on the \"Play\" button."
    },
    "playReplay": {
      "title": "Start replay",
      "content": "Remember to start the replay by clicking on the \"Play\" button."
    }
  },
  "tooltip": {
    "askLive": {
      "on": "Leave the live",
      "off": "Join the live"
    },
    "camera": {
      "on": "Disable camera",
      "off": "Activate camera"
    },
    "audio": {
      "on": "Disable microphone",
      "off": "Activate microphone"
    },
    "screen": {
      "on": "Stop sharing your screen",
      "off": "Share your screen"
    },
    "openDocuments": {
      "on": "Hide documents",
      "off": "Show documents",
      "prev": "Previous page<br>(left arrow of the keyboard)",
      "next": "Next page<br>(right arrow of the keyboard)"
    }
  },
  "replayNotAvailable": {
    "title": "The replay will be available soon...",
    "content": {
      "text1": "The replay of the webinar is not available yet.",
      "text2": "Try again in a few minutes."
    }
  },
  "notification": {
    "connectionDrop" : {
      "title": "Your network is unstable.",
      "content": "We recommend that you check your network and close unused applications."
    }
  },
  "toastr": {
    "speakersStreamsLimitReached": "You have reached the limit of the number of speakers allowed per webinar.",
    "profileInfo": "To be able to edit your profile, please stop your broadcast commands (camera and microphone)",
    "sharingScreen": "Unsupported screen sharing",
    "installExtension": "Please install the plugin",
    "toBeLive": "You have to be in live",
    "requestSend": "Your request has been sent",
    "requestAsk": "has sent you a request",
    "requestAccepted": "Your request is accepted",
    "requestRefused": "Your request is refused",
    "requestByAccceptedBy": "The request for {requestedBy} was allowed by {acceptedBy}",
    "requestByRefusedBy": "The request for {requestedBy} was refused by {refusedBy}",
    "docUpdate": "The downloadable files have been updated",
    "firstnameRequired": "The first name is required",
    "lastnameRequired": "The name is required",
    "emailRequired": "Email is required",
    "inline": "On-line",
    "offline": "Offline",
    "is": "is",
    "newPoll": "A new poll is available",
    "publishPoll": "The results of the poll have been published",
    "closePoll": "A poll has just been closed",
    "createPoll": "A new poll has just been created",
    "deletePoll": "A poll has just been deleted",
    "resetedPoll": "Your poll is re-initialized",
    "editedPoll": "Your poll has been modified",
    "browserNotSupport": "Screen sharing is not supported by your browser",
    "screenShareCancel": "Screen sharing has been cancelled",
    "chat": {
      "emptyPublicChatForbidden": "You can no longer delete the content of the chat more than 15 minutes before the start of the webinar.",
      "emptyPublicChatSuccess": "The content of the chat has been deleted.",
      "deleteChatMessageSuccess": "The message has been deleted.",
      "validateChatMessageSuccess": "The message has been validated."
    },
    "documents": {
      "errors": {
        "uploadInvalidPresentationDocumentCount": "You can not download multiple PPT files at one time. Please download these files one by one.",
        "uploadInvalidFileType": "Incompatible format: only MP4, PDF, PNG and JPEG are allowed",
        "uploadInvalidFileSizeVideo": "File too large: videos should not exceed 300 MB",
        "uploadInvalidFileSizeOthers": "File too large: files should not exceed 20 MB",
        "updateDownloadable": "You do not have the rights to this document to make it downloadable, please contact the owner.",
        "splitFailed": "The document could not be saved",
        "splitTimeout": "The document could not be saved",
        "deleteForbidden": "You do not have the rights to delete this document, please contact the owner.",
        "deleteCurrentSharing": "You cannot delete a document in progress.",
        "roomResetFailedDueToPostProd": "Unable to reset the room, post-production is in progress, please wait before trying again"
      }
    }
  }
}}